module.exports = __webpack_public_path__ + "static/media/1006087.3b30c23f.png";